// extracted by mini-css-extract-plugin
export var modal = "_l1-0";